import { SVGProps, Ref, forwardRef } from 'react';

export const DrawerOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.106 12.367c.497-3.689 1.138-5.825 1.997-7.04C5.816 4.318 6.783 3.8 8.7 3.8h6.6c1.917 0 2.884.519 3.596 1.526.86 1.216 1.501 3.352 1.997 7.04q.05.378.094.734h-4.86l-.75 2H8.623l-.75-2h-4.86q.042-.356.092-.733M2.845 14.9a18 18 0 0 0-.035 1.826c.042 1.137.223 1.858.45 2.315.2.406.458.648.836.822.429.197 1.092.337 2.123.337H17.78c1.032 0 1.695-.14 2.124-.337.378-.174.635-.416.837-.822.226-.457.407-1.178.45-2.315a18 18 0 0 0-.036-1.826h-3.781l-.75 2H7.376l-.75-2zM8.7 2C4.031 2 2.319 4.722 1.323 12.127.326 19.532 1.55 22 6.219 22H17.78c4.67 0 5.894-2.468 4.897-9.873S19.97 2 15.3 2z"
                fill="currentColor"
            />
        </g>
    </svg>
));
DrawerOutlinedSize24Glyph.displayName = 'DrawerOutlinedSize24Glyph';
